import { Dispatch, SetStateAction } from 'react';

import { Field } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';

import { Fields, FieldWrapper, inputStyle, Item } from '../pricingHeaderStyle';

interface IProps {
  onBlur: (value: string, refValue: React.MutableRefObject<string>) => void;
  price: string;
  setPrice: Dispatch<SetStateAction<string>>;
  uom: string;
  setUom: Dispatch<SetStateAction<string>>;
  uomRef: React.MutableRefObject<string>;
  priceRef: React.MutableRefObject<string>;
}

const ENTER_KEYCODE = 13;

const ManualPriceFieldsView = ({
  onBlur,
  price,
  setPrice,
  uom,
  setUom,
  uomRef,
  priceRef,
}: IProps) => {
  return (
    <Fields>
      <Item padding={5} bold>
        $
      </Item>

      <FieldWrapper>
        <Field
          type={InputType.TEXTFIELD}
          name="price"
          inputProps={{
            style: inputStyle,
            size: Size.MD,
            value: price,
            onBlur: () => onBlur(price, priceRef),
            onChange: (e) => setPrice(e.target.value),
            onKeyDown: (e) => {
              if (e?.keyCode === ENTER_KEYCODE) {
                onBlur(price, priceRef);
              }
            },
          }}
        />
      </FieldWrapper>

      <Item padding={5} bold>
        /
      </Item>

      <FieldWrapper>
        <Field
          type={InputType.TEXTFIELD}
          name="uom"
          inputProps={{
            style: inputStyle,
            size: Size.MD,
            value: uom,
            onBlur: () => onBlur(uom, uomRef),
            onChange: (e) => setUom(e.target.value),
            onKeyDown: (e) => {
              if (e?.keyCode === ENTER_KEYCODE) {
                onBlur(uom, uomRef);
              }
            },
          }}
        />
      </FieldWrapper>
    </Fields>
  );
};

export default ManualPriceFieldsView;
